"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BALANCE_TYPE_V2 = exports.VerifyCodeType = exports.VerifyCodeAction = exports.WhiteListStatus = void 0;
var WhiteListStatus;
(function (WhiteListStatus) {
    WhiteListStatus["on"] = "on";
    WhiteListStatus["off"] = "off";
})(WhiteListStatus = exports.WhiteListStatus || (exports.WhiteListStatus = {}));
var VerifyCodeAction;
(function (VerifyCodeAction) {
    VerifyCodeAction["login"] = "login";
    VerifyCodeAction["withdraw"] = "withdraw";
    VerifyCodeAction["register"] = "register";
    VerifyCodeAction["forgetPassword"] = "forget_password";
    VerifyCodeAction["accountBind"] = "account_bind";
    VerifyCodeAction["add_whitelist_address"] = "add_whitelist_address";
    VerifyCodeAction["modify_address_tag"] = "modify_address_tag";
    VerifyCodeAction["move_to_whitelist_address"] = "move_to_whitelist_address";
    VerifyCodeAction["move_out_whitelist_address"] = "move_out_whitelist_address";
    VerifyCodeAction["open_whitelist_withdraw"] = "open_whitelist_withdraw";
    VerifyCodeAction["close_whitelist_withdraw"] = "close_whitelist_withdraw";
    VerifyCodeAction["reset_otp"] = "reset_otp";
    VerifyCodeAction["kyc"] = "kyc";
    VerifyCodeAction["close_user"] = "close_user";
    VerifyCodeAction["account_unbind"] = "account_unbind";
    VerifyCodeAction["bind_otp"] = "bind_otp";
    VerifyCodeAction["reset_security_account"] = "reset_security_account";
    VerifyCodeAction["pay_subscription_fee"] = "pay_subscription_fee";
    VerifyCodeAction["openapi_createkey"] = "openapi_createkey";
    VerifyCodeAction["openapi_modifykey"] = "openapi_modifykey";
    VerifyCodeAction["openapi_delkey"] = "openapi_delkey";
    VerifyCodeAction["bind_biometric_keys"] = "bind_biometric_keys";
})(VerifyCodeAction = exports.VerifyCodeAction || (exports.VerifyCodeAction = {}));
var VerifyCodeType;
(function (VerifyCodeType) {
    VerifyCodeType["sms"] = "sms";
    VerifyCodeType["email"] = "email";
    VerifyCodeType["voice"] = "voice";
})(VerifyCodeType = exports.VerifyCodeType || (exports.VerifyCodeType = {}));
var BALANCE_TYPE_V2;
(function (BALANCE_TYPE_V2) {
    BALANCE_TYPE_V2["TRADE"] = "TRADE";
    BALANCE_TYPE_V2["DEBT"] = "DEBT";
    BALANCE_TYPE_V2["SWAP"] = "SWAP";
    BALANCE_TYPE_V2["ARBITRAGE_STRATEGY"] = "ARBITRAGE_STRATEGY";
    BALANCE_TYPE_V2["CM_SWAP"] = "CM_SWAP";
    BALANCE_TYPE_V2["DEPOSIT"] = "DEPOSIT";
    BALANCE_TYPE_V2["DUAL"] = "DUAL";
    BALANCE_TYPE_V2["DUAL_AUTO"] = "DUAL_AUTO";
    BALANCE_TYPE_V2["MODULE_FINANCE"] = "MODULE_FINANCE";
    BALANCE_TYPE_V2["TRADER_ACCOUNT"] = "TRADER_ACCOUNT";
})(BALANCE_TYPE_V2 = exports.BALANCE_TYPE_V2 || (exports.BALANCE_TYPE_V2 = {}));
